/**
 *
 * PartnerAssist Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { lazyLoad } from 'utils/loadable';

const lazyPartnerAssistPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'BusinessEnquiryPage', webpackPrefetch: true */ '../BusinessEnquiry/index'
    ),
  module => module.default,
);

const lazyPartnerContactsPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'PartnerContactsPage', webpackPrefetch: true */ '../Crm/ContactListing'
    ),
  module => module.default,
);

const lazyPartnerCompanyPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'PartnerCompanyPage', webpackPrefetch: true */ '../Crm/CompanyListing'
    ),
  module => module.default,
);

export const lazyOrderPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'OrderPage', webpackPrefetch: true */ '../Order/index'
    ),
  module => module.default,
);
// routes declaration
export const partnerAssistRoutes = [
  {
    component: lazyPartnerAssistPage,
    path: '/partner-assist/leads',
    title: 'Partner Leads',
    isPartner: true,
    needsAuth: true,
    hidePublicNavbar: true,
    // hideCustomFooter: true,
    // allowedAfterLogin: true,
  },
  {
    component: lazyPartnerContactsPage,
    path: '/partner-assist/contacts',
    title: 'Partner Contacts',
    isPartner: true,
    needsAuth: true,
  },
  {
    component: lazyPartnerCompanyPage,
    path: '/partner-assist/companies',
    title: 'Partner Companies',
    isPartner: true,
    needsAuth: true,
  },
  {
    component: lazyOrderPage,
    path: '/partner-assist/orders',
    title: 'Orders',
    needsAuth: true,
    isPartner: true,
  },
];
